import { lazy } from "react";
import { roles } from ".";

/**
 * Route trees are lazy so each role only downloads its own dashboard. Before
 * this, every student pulled the admin bundle (MUI X-Charts, ApexCharts, the
 * control panel) on first paint.
 */
const AdminEditorRoutes = lazy(() => import("../NewPages/AdminEditorRoutes"));
const AdminRoutes = lazy(() => import("../NewPages/AdminRoutes"));
const ArchiveStudentRoutes = lazy(() =>
  import("../NewPages/ArchiveStudentRoutes")
);
const InstructorRoutes = lazy(() => import("../NewPages/InstructorRoutes"));
const QAInstructorRoutes = lazy(() => import("../NewPages/QAInstructorRoutes"));
const StudentRoutes = lazy(() => import("../NewPages/StudentRoutes"));
const WebinarInstructorRoutes = lazy(() =>
  import("../NewPages/WebinarInstructorRoutes")
);

export const roleRoutesLookup = {
  [roles.studentRole]: <StudentRoutes />,
  [roles.studentArchiveRole]: <ArchiveStudentRoutes />,
  [roles.instructorRole]: <InstructorRoutes />,
  [roles.webinarInstructorRole]: <WebinarInstructorRoutes />,
  [roles.qaInstructorRole]: <QAInstructorRoutes />,
  [roles.admin]: <AdminRoutes />,
  [roles.adminEditor]: <AdminEditorRoutes />,
};
